import PropTypes from 'prop-types';

export const Icons = ({ className, variant }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.INCREASE: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 15L14 6M14 6H7M14 6V13"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DECREASE: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 5L14 14M14 14H7M14 14V7"
              stroke="#EC455E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.ELLIPSE: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
          >
            <mask
              id="mask0_78641_106828"
              maskUnits="userSpaceOnUse"
              x="9"
              y="12"
              width="30"
              height="25"
            >
              <path
                d="M17 14H37M17 28H37M11 21H31M11 35H31"
                stroke="#51BFE1"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </mask>
            <g mask="url(#mask0_78641_106828)">
              <rect x="9" y="11" width="31" height="27" fill="url(#paint0_linear_78641_106828)" />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_78641_106828"
                x1="16.5"
                y1="13"
                x2="44.5"
                y2="32"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#51BFE1" />
                <stop offset="1" stopColor="#4673D1" />
              </linearGradient>
            </defs>
          </svg>
        );
      }
      case Icons.ACTIVITY: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.5 9.99967H14.1667L11.6667 16.6663L8.33333 3.33301L5.83333 9.99967H2.5"
              stroke="#FB913A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.CLIENTS: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10.4167 6.66634C10.4167 8.50729 8.92428 9.99967 7.08333 9.99967C5.24238 9.99967 3.75 8.50729 3.75 6.66634C3.75 4.82539 5.24238 3.33301 7.08333 3.33301C8.92428 3.33301 10.4167 4.82539 10.4167 6.66634Z"
              stroke="#51BFE1"
              strokeWidth="2"
            />
            <path
              d="M12.9167 9.99967C14.7576 9.99967 16.25 8.50729 16.25 6.66634C16.25 4.82539 14.7576 3.33301 12.9167 3.33301"
              stroke="#51BFE1"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M2.08331 16.2497C2.39493 14.6916 3.82761 13.333 5.41654 13.333H8.74998C10.3389 13.333 11.7717 14.6916 12.0833 16.2497"
              stroke="#51BFE1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5833 13.333C16.1722 13.333 17.605 14.6916 17.9166 16.2497"
              stroke="#51BFE1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.LISTING: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 5.83464H15.8327M15.8327 5.83464L12.916 2.91797M15.8327 5.83464L12.916 8.7513"
              stroke="#928CDA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.833 14.1667H4.16634M4.16634 14.1667L7.08301 11.25M4.16634 14.1667L7.08301 17.0833"
              stroke="#928CDA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.PURCHASE: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 5.83464H15.8327M15.8327 5.83464L12.916 2.91797M15.8327 5.83464L12.916 8.7513"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.833 14.1667H4.16634M4.16634 14.1667L7.08301 11.25M4.16634 14.1667L7.08301 17.0833"
              stroke="#00B152"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DUAL: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 5.83464H15.8327M15.8327 5.83464L12.916 2.91797M15.8327 5.83464L12.916 8.7513"
              stroke="#4673D1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.833 14.1667H4.16634M4.16634 14.1667L7.08301 11.25M4.16634 14.1667L7.08301 17.0833"
              stroke="#4673D1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EDIT: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <g opacity="0.8">
              <path
                d="M10.3125 14.375C10.3125 13.5121 9.61295 12.8125 8.75 12.8125C7.88706 12.8125 7.1875 13.5121 7.1875 14.375C7.1875 15.2379 7.88706 15.9375 8.75 15.9375C9.61295 15.9375 10.3125 15.2379 10.3125 14.375Z"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.75 14.375L7.1875 14.375"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.3125 14.375L16.25 14.375"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.3125 10C15.3125 9.13705 14.6129 8.4375 13.75 8.4375C12.8871 8.4375 12.1875 9.13705 12.1875 10C12.1875 10.8629 12.8871 11.5625 13.75 11.5625C14.6129 11.5625 15.3125 10.8629 15.3125 10Z"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.75 10L12.1875 10"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.3125 10H16.25"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.8125 5.625C7.8125 4.76205 7.11295 4.0625 6.25 4.0625C5.38706 4.0625 4.6875 4.76205 4.6875 5.625C4.6875 6.48794 5.38706 7.1875 6.25 7.1875C7.11295 7.1875 7.8125 6.48794 7.8125 5.625Z"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.75 5.625H4.6875"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.125 5.625L16.2502 5.625"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.PERSON: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
              stroke="#515151"
              strokeWidth="2"
            />
            <path
              d="M5.25 20.625C5.67068 18.2211 7.6048 16.125 9.74986 16.125H14.25C16.3951 16.125 18.3293 18.2211 18.75 20.625"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.CHAT: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5.18229 16.0581L6.10236 16.4498L6.30022 15.9851L6.04365 15.5501L5.18229 16.0581ZM3.54135 19.912L2.62128 19.5203H2.62128L3.54135 19.912ZM4.18134 20.5744L4.54126 21.5074H4.54127L4.18134 20.5744ZM8.22693 19.0137L8.70903 18.1376L8.30125 17.9132L7.86701 18.0807L8.22693 19.0137ZM20.0781 12H19.0781C19.0781 15.866 15.9441 19 12.0781 19V20V21C17.0487 21 21.0781 16.9706 21.0781 12H20.0781ZM12.0781 4V5C15.9441 5 19.0781 8.13401 19.0781 12H20.0781H21.0781C21.0781 7.02944 17.0487 3 12.0781 3V4ZM4.07811 12H5.07811C5.07811 8.13401 8.21212 5 12.0781 5V4V3C7.10755 3 3.07811 7.02944 3.07811 12H4.07811ZM5.18229 16.0581L6.04365 15.5501C5.43029 14.51 5.07811 13.2977 5.07811 12H4.07811H3.07811C3.07811 13.6647 3.53101 15.2267 4.32093 16.5661L5.18229 16.0581ZM3.54135 19.912L4.46142 20.3038L6.10236 16.4498L5.18229 16.0581L4.26222 15.6663L2.62128 19.5203L3.54135 19.912ZM4.18134 20.5744L3.82143 19.6414C4.23372 19.4824 4.63454 19.8972 4.46142 20.3038L3.54135 19.912L2.62128 19.5203C2.10191 20.7401 3.30435 21.9846 4.54126 21.5074L4.18134 20.5744ZM8.22693 19.0137L7.86701 18.0807L3.82142 19.6414L4.18134 20.5744L4.54127 21.5074L8.58685 19.9467L8.22693 19.0137ZM12.0781 20V19C10.8548 19 9.70754 18.687 8.70903 18.1376L8.22693 19.0137L7.74484 19.8898C9.03123 20.5977 10.5092 21 12.0781 21V20Z"
              fill="#515151"
            />
          </svg>
        );
      }
      case Icons.TASK: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 5.83366H15.8327M15.8327 5.83366L12.916 2.91699M15.8327 5.83366L12.916 8.75033"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.833 14.1667H4.16634M4.16634 14.1667L7.08301 11.25M4.16634 14.1667L7.08301 17.0833"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.OFFER: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M11.667 2.5V5.83333C11.667 6.05435 11.7548 6.26631 11.9111 6.42259C12.0674 6.57887 12.2793 6.66667 12.5003 6.66667H15.8337"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.167 17.5H5.83366C5.39163 17.5 4.96771 17.3244 4.65515 17.0118C4.34259 16.6993 4.16699 16.2754 4.16699 15.8333V4.16667C4.16699 3.72464 4.34259 3.30072 4.65515 2.98816C4.96771 2.67559 5.39163 2.5 5.83366 2.5H11.667L15.8337 6.66667V15.8333C15.8337 16.2754 15.6581 16.6993 15.3455 17.0118C15.0329 17.3244 14.609 17.5 14.167 17.5Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.8 8.75C11.8 8.75 11.2 8 10 8C8.8 8 8.2 8.75 8.2 9.5C8.2 11.375 12 10.4 12 12.5C12 13.4 11.3333 14 10 14C8.66667 14 8 13.1 8 13.1"
              stroke="#515151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 7V15"
              stroke="#515151"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.FORM: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M3.33398 3.66699C3.33398 2.56242 4.22941 1.66699 5.33398 1.66699H11.8021C12.0712 1.66699 12.3289 1.77546 12.5171 1.96787L16.3823 5.92098C16.565 6.10783 16.6673 6.35877 16.6673 6.62009V16.3337C16.6673 17.4382 15.7719 18.3337 14.6673 18.3337H5.33398C4.22941 18.3337 3.33398 17.4382 3.33398 16.3337V3.66699Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.666 1.66699V4.66699C11.666 5.77156 12.5614 6.66699 13.666 6.66699H16.666"
              stroke="#515151"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.ARROWS: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 5.83366H15.8327M15.8327 5.83366L12.916 2.91699M15.8327 5.83366L12.916 8.75033"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.833 14.1667H4.16634M4.16634 14.1667L7.08301 11.25M4.16634 14.1667L7.08301 17.0833"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.COPY: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <g clipPath="url(#clip0_82529_283656)">
              <path
                d="M8.86393 3.33203L14.47 3.33203C14.912 3.33203 15.3359 3.50763 15.6485 3.82019C15.9611 4.13275 16.1367 4.55667 16.1367 4.9987V12.4987C16.1367 12.9407 15.9611 13.3646 15.6485 13.6772C15.3359 13.9898 14.912 14.1654 14.47 14.1654H8.86393C8.4219 14.1654 7.99798 13.9898 7.68542 13.6772C7.37286 13.3646 7.19727 12.9407 7.19727 12.4987V4.9987C7.19727 4.55667 7.37286 4.13275 7.68542 3.82019C7.99798 3.50763 8.4219 3.33203 8.86393 3.33203Z"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.8027 14.168V15.8346C12.8027 16.2767 12.6271 16.7006 12.3145 17.0131C12.002 17.3257 11.578 17.5013 11.136 17.5013H5.52995C5.08792 17.5013 4.664 17.3257 4.35144 17.0131C4.03888 16.7006 3.86328 16.2767 3.86328 15.8346V8.33464C3.86328 7.89261 4.03888 7.46869 4.35144 7.15612C4.664 6.84356 5.08792 6.66797 5.52995 6.66797H7.19661"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_82529_283656">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.RESEND: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="16"
            viewBox="0 0 13 16"
            fill="none"
          >
            <g clipPath="url(#clip0_82529_283648)">
              <path
                d="M1.0201 9.03009C0.922233 10.1718 1.18343 11.3156 1.7672 12.3017C2.35097 13.2878 3.22816 14.0669 4.27624 14.5302C5.32432 14.9935 6.49094 15.1179 7.61314 14.886C8.73535 14.6541 9.75709 14.0774 10.5356 13.2366C11.3142 12.3958 11.8107 11.3328 11.9558 10.1961C12.1008 9.05936 11.8872 7.90573 11.3448 6.89633C10.8024 5.88692 9.95819 5.07215 8.9302 4.56582C7 3.61512 4 4 4 4M4 4L7 1M4 4L7 6.89633"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_82529_283648">
                <rect width="13" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.SEND: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10.6247 9.16665L6.91351 11.0349M6.91351 11.0349L6.24943 10.3261L2.57491 6.71298C1.93676 6.08549 2.38107 4.99994 3.27604 4.99995L17.124 4.99997C17.9558 4.99998 18.424 5.95617 17.914 6.61316L9.42769 17.5455C8.87705 18.2548 7.74304 17.9352 7.64387 17.0427L7.08276 11.9928L6.91351 11.0349Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.CALENDER: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M14.5 4H5.5C4.67157 4 4 4.67157 4 5.5V14.5C4 15.3284 4.67157 16 5.5 16H14.5C15.3284 16 16 15.3284 16 14.5V5.5C16 4.67157 15.3284 4 14.5 4Z"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 3V5"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 3V5"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 8H16"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.LOCATION: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <ellipse cx="10" cy="9.16699" rx="2.5" ry="2.5" stroke="#515151" strokeWidth="2" />
            <path
              d="M16.6673 9.16667C16.6673 12.8846 12.9812 16.3721 11.0908 17.9162C10.4494 18.4401 9.55192 18.4401 8.91046 17.9162C7.02011 16.3721 3.33398 12.8846 3.33398 9.16667C3.33398 5.48477 6.31875 2.5 10.0007 2.5C13.6825 2.5 16.6673 5.48477 16.6673 9.16667Z"
              stroke="#515151"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.ARROW_LEFT: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.6943 18.6943C15.2861 19.1017 14.6243 19.1017 14.2161 18.6943L8.303 12.7931C8.0773 12.5679 7.9764 12.2653 8.0003 11.9708C7.9942 11.696 8.0961 11.4193 8.306 11.2096L14.2164 5.30568C14.6244 4.8981 15.286 4.8981 15.694 5.30568C16.102 5.71326 16.102 6.37408 15.694 6.78166L10.4674 12.0025L15.6943 17.219C16.1025 17.6264 16.1025 18.2869 15.6943 18.6943Z"
              fill="#747475"
            />
          </svg>
        );
      }
      case Icons.ARROW_RIGHT: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.30567 18.6943C8.71388 19.1017 9.37573 19.1017 9.78394 18.6943L15.697 12.7931C15.9227 12.5679 16.0236 12.2653 15.9997 11.9708C16.0058 11.696 15.9039 11.4193 15.694 11.2096L9.78361 5.30568C9.37558 4.8981 8.71404 4.8981 8.30601 5.30568C7.89799 5.71326 7.89799 6.37408 8.30601 6.78166L13.5326 12.0025L8.30567 17.219C7.89746 17.6264 7.89746 18.2869 8.30567 18.6943Z"
              fill="#747475"
            />
          </svg>
        );
      }

      default:
        return null;
    }
  };
  return <div className={className}>{renderIcon()}</div>;
};

Icons.INCREASE = 'increase';
Icons.DECREASE = 'decrease';
Icons.ELLIPSE = 'ellipse';
Icons.ACTIVITY = 'activity';
Icons.CLIENTS = 'clients';
Icons.LISTING = 'listing';
Icons.PURCHASE = 'purchase';
Icons.DUAL = 'dual';
Icons.EDIT = 'edit';
Icons.PERSON = 'person';
Icons.CHAT = 'chat';
Icons.TASK = 'task';
Icons.OFFER = 'offer';
Icons.FORM = 'form';
Icons.ARROWS = 'arrows';
Icons.COPY = 'copy';
Icons.RESEND = 'resend';
Icons.SEND = 'send';
Icons.CALENDER = 'calender';
Icons.LOCATION = 'location';
Icons.ARROW_LEFT = 'arrowLeft';
Icons.ARROW_RIGHT = 'arrowRight';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
};

Icons.defaultProps = {
  className: '',
  variant: '',
};
